import * as React from 'react'

import Button from '@doordash/component-button'
import Toggle from '@doordash/component-toggle'

import { Text, Colors, Stack, StackChildren } from '@doordash/design-language'
import { FeatureFlag } from '@doordash/lib-feature-flags'
import Form from '../../../../utilities/Form'
// tslint:disable-next-line:max-line-length
import { validators as sharedValidators } from '../../../../utilities/validators'
import AustralianBusinessNumber from '../../../atoms/australian-business-number'
import {
  BirthdateInput,
  BirthdateInputSplit,
} from '../../../atoms/birthdate-input'
import { VehicleTypeDropdown } from '../../../atoms/vehicle-type-dropdown'

import * as moment from 'moment'

import t from './strings'
import { PageExplanation } from './styles'

const minBirthday = moment()
  .subtract(18, 'years')
  .format('YYYY-MM-DD')

type Props = {
  uniqueLink?: string
  error?: string
  onSubmit?: (any) => Promise<any>
  doSubmit?: (uniqueLink: string, backgroundInfo: object) => Promise<any>
  vehicleTypes?: any
}

export class Australia extends React.Component<Props> {
  public static fields = {
    vehicleType: -1,
    birthday: '',
    australianBusinessNumber: '',
    isGstRegistered: false,
  }

  public static validators = {
    vehicleType: sharedValidators.vehicleType,
    birthday: sharedValidators.birthday,
    australianBusinessNumber: sharedValidators.australianBusinessNumber,
    isGstRegistered: sharedValidators.isGstRegistered,
  }

  public processVehicleTypes = vehicleTypes => {
    const vehicleTypesArray = []
    for (const key of Object.keys(vehicleTypes)) {
      const obj = vehicleTypes[key]
      obj.value = key
      vehicleTypesArray.push(obj)
    }

    return vehicleTypesArray
  }

  public handleSubmit = async data => {
    const { doSubmit, uniqueLink } = this.props
    try {
      const res = await doSubmit(uniqueLink, data)
      return res
    } catch (e) {
      throw e
    }
  }

  public render() {
    const { vehicleTypes } = this.props

    return (
      <React.Fragment>
        <Text color={Colors.SystemRed60} styles={Text.Styles.MajorPageTitle}>
          {t.australiaPageTitle()}
        </Text>

        <Form
          onSubmit={this.handleSubmit}
          validators={Australia.validators}
          fields={Australia.fields}
        >
          {(fields, handleChange, handleSubmit, { isLoading }) => (
            <form onSubmit={handleSubmit}>
              <PageExplanation>{t.vehicleExplanation()}</PageExplanation>
              <Stack />
              <StackChildren size={StackChildren.Sizes.Large}>
                <VehicleTypeDropdown
                  label={t.vehicleTypeLabel()}
                  description={t.required()}
                  vehicleTypes={this.processVehicleTypes(vehicleTypes)}
                  onChange={handleChange.bind(this, 'vehicleType')}
                  {...fields.vehicleType}
                />
                <BirthdateInputSplit
                  id="birthdate-input-split"
                  label={t.birthdate()}
                  onChange={handleChange.bind(this, 'birthday')}
                  birthdayField={fields.birthday}
                  {...fields.birthday}
                />
                <AustralianBusinessNumber
                  label="ABN"
                  description={t.required()}
                  onChange={handleChange.bind(this, 'australianBusinessNumber')}
                  {...fields.australianBusinessNumber}
                />

                <Toggle
                  label={t.isGstRegistered()}
                  alignToggle={Toggle.Alignment.Center}
                  type={Toggle.Types.Checkbox}
                  onChange={handleChange.bind(this, 'isGstRegistered')}
                  isSelected={fields.isGstRegistered.value}
                  {...fields.isGstRegistered}
                />

                <Button
                  onClick={async () => {
                    try {
                      await handleSubmit()
                    } catch (e) {
                      console.warn(e)
                    }
                  }}
                  state={
                    isLoading ? Button.States.Loading : Button.States.Default
                  }
                >
                  {t.continue()}
                </Button>
              </StackChildren>
            </form>
          )}
        </Form>
      </React.Fragment>
    )
  }
}

export default Australia
